import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EInvoice } from 'api/public/types';
import { userApi } from 'api/public/user/api';
import { RecipientInfo, User } from 'api/public/user/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { RootState } from 'shared/redux/store';
import { AuthState } from './types';

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
};

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    updateAccessToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
      state.isAuthenticated = true;
    },
    updateRecipientInfo(state, action: PayloadAction<RecipientInfo>) {
      state.recipient_info = action.payload;
    },
    updateEInvoice(state, action: PayloadAction<EInvoice>) {
      state.e_invoice = action.payload;
    },
    resetAuth(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userApi.endpoints.getUserProfile.matchFulfilled,
        (state, action: PayloadAction<User | null>) => {
          console.log('getUserProfile.matchFulfilled', action.payload?._id);
          state.user = action.payload;
          if (!state.recipient_info && action.payload) {
            state.recipient_info = {
              name: action.payload.name,
              mobile:
                action.payload._id && action.payload._id.startsWith('84')
                  ? action.payload._id.replace('84', '0')
                  : '',
            };
          }
        }
      )
      .addMatcher(userApi.endpoints.getUserProfile.matchRejected, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
      });
  },
});

export const authReducer = persistReducer(
  {
    key: 'auth',
    storage,
    whitelist: ['user', 'recipient_info', 'e_invoice'],
  },
  authSlice.reducer
);

// SELECTOR
export const selectUser = (state: RootState) => state.authSlice.user;
export const selectRecipientInfo = (state: RootState) =>
  state.authSlice.recipient_info;
export const selectToken = (state: RootState) => state.authSlice.token;
export const selectIsAuthenticated = (state: RootState) =>
  state.authSlice.isAuthenticated;
export const selectEInvoice = (state: RootState) => state.authSlice.e_invoice;
